import React, { Component } from 'react'
import { connect } from 'react-redux'
import { hideProductModal, showMessageModal } from '../../../redux/actions/miscActions'
import { toggleProductVisibile, deleteProduct, updateProduct } from '../../../redux/actions/productActions'
import { Modal } from 'antd';
import { Form, Input, Select, Switch, Checkbox   } from 'antd'

const { TextArea } = Input;
const { Option } = Select;

export class EditModal extends Component {
  constructor(props){
    super(props)
    this.state={
      isVisible: '', productAttributen: [], productCategorie: '', productId: '', productImage: '', productNaam: '', productOmschrijving: '', productOnSale: '', productPrijs: '', productEenheid: '', salesPrice: '', imgPreview: '', confirmDelete: ''
    }
  }

  handleConfirm=(e)=>{
    this.setState({
      [e.target.name]: e.target.value.toUpperCase()
    })
  }

  handleCancel=()=>{
    this.props.hideProductModal()
  }
  
  componentDidUpdate=(prevProps)=>{
    const { isVisible, productAttributen, productCategorie, productId, productImage, productNaam, productOmschrijving, productOnSale, productPrijs, productEenheid, salesPrice } = this.props.misc.editProduct
    if(prevProps.misc.editProduct !== this.props.misc.editProduct){

      this.setState({
        isVisible, productAttributen, productCategorie, productId, productImage, productNaam, productOmschrijving, productOnSale, productEenheid, productPrijs: productPrijs ? productPrijs.replace(/\./g, ',') : productPrijs, salesPrice: salesPrice ? salesPrice.replace(/\./g, ',') : salesPrice, imgPreview: productImage
      })
    }
  }

  handleImageSelect = (e) => {
    
    if (e.target.files.length === 1) {
      const imgPreview = URL.createObjectURL(e.target.files[0]);
      this.setState({
        imgPreview,
        productImage: e.target.files[0],
      });
    }
  };

  handleInput=(e)=>{
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleNumberInput=(e)=>{
    if(e.target.value.match(/^[0-9]+([0-9,]{1,3})?$/gm)){
      this.setState({
        [e.target.name]: e.target.value
      })
    } else if (e.target.value.length === 0){
      this.setState({
        [e.target.name]: ''
      })
    }
  }

  handleConfirm=(e)=>{
    this.setState({
      [e.target.name]: e.target.value.toUpperCase()
    })
  }

  handleCatSelect=(value)=>{    
    this.setState({
      productCategorie: value
    })
  }


  handleProductEenheid=(value)=>{    
    this.setState({
      productEenheid: value
    })
  }


  handleAttributenSelect=(value)=>{
    this.setState({
      productAttributen: value
    })
  }

  handleOnSaleSelect=(e)=>{
    this.setState({
      productOnSale: e.target.checked
    })
  }

  toggleIsActive=(e)=>{
    const { id } = this.props.misc.editProduct
    const { allClientProducts } = this.props.products
    const { productNaam } = this.state
    if(e === true && allClientProducts.filter(x => x.isVisible === true).length >= 80){
      const feedback = {
        type: 'warning',
        txt: 'U heeft uw limiet van zichtbare producten bereikt.'
      }
      this.props.showMessageModal(feedback)
    } else {
      this.props.toggleProductVisibile(id, e, productNaam)
      this.setState({
        isVisible: e
      })
    }
  }
  
  handleProductUpdate=()=>{
    const { id } = this.props.misc.editProduct
    const {productAttributen, productCategorie, productId, productNaam, productOmschrijving, productOnSale, productPrijs, productEenheid, salesPrice, productImage } = this.state
    
    const data = { productAttributen, productCategorie, productId, productNaam, productOmschrijving, productOnSale, productPrijs, productEenheid, salesPrice, productImage }

    data.productPrijs = productPrijs.replace(/,/g, '.')
    productOnSale ? data.salesPrice = salesPrice.replace(/,/g, '.') : data.salesPrice = salesPrice
    
    if(productNaam && productImage && productCategorie.length > 0 && productPrijs ){
      this.props.updateProduct(id, data)
    } else {
      const feedback = {
        type: 'warning',
        txt: 'Controleer als alle velden zijn ingevuld.'
      }
      this.props.showMessageModal(feedback)
    }
    
  }
  
  deleteProduct=()=>{
    const { id } = this.props.misc.editProduct
    this.props.deleteProduct(id)
  }

  render() {
    const { isProductModalVisible } = this.props.misc
    const attributen = [
      <Option key="Bevroren">Bevroren</Option>,
      <Option key="Bosjes">Bosjes</Option>,
      <Option key="Cubes verpakt">Cubes verpakt</Option>,
      <Option key="Fijngesneden">Fijngesneden</Option>,
      <Option key="Geschild">Geschild</Option>,
      <Option key="Gesneden">Gesneden</Option>,
      <Option key="Heel">Heel</Option>,
      <Option key="Ongeschild">Ongeschild</Option>,
      <Option key="Sap met pulp">Sap met pulp</Option>,
      <Option key="Schoongemaakt">Schoongemaakt</Option>,
      <Option key="Uitgehold">Uitgehold</Option>,
      <Option key="Verpakt">Verpakt</Option>,
      <Option key="Vers">Vers</Option>  
    ]
    const {isVisible, productAttributen, productCategorie, productId, productNaam, productOmschrijving, productOnSale, productPrijs, productEenheid, salesPrice, imgPreview, confirmDelete } = this.state
    return (
      <div>
          <Modal
          className="edit-product-modal"
          footer={null}
          visible={isProductModalVisible}
          onCancel={this.handleCancel}
        >
          <div className="header">
            <p>Product is zichtbaar</p>
            <Switch checked={isVisible} onChange={(e)=>this.toggleIsActive(e)} />
          </div>
<Form layout="vertical">
            <Form.Item label="Product foto">
          <div className="image-preview">
            <img src={imgPreview} alt=""/>
              <Input
                type="file"
                className="form-control-file"
                onChange={this.handleImageSelect}                
              />
          </div>
            </Form.Item>

            <Form.Item label="Product naam" required={true}>
              <Input name="productNaam" onChange={this.handleInput} value={productNaam} />
            </Form.Item>

            <Form.Item label="Product categorie" required={true}>
              <Select value={productCategorie} onChange={this.handleCatSelect}>
                <Option value="groenten">Groenten</Option>
                <Option value="fruit">Fruit</Option>
                <Option value="sap">Sap</Option>
                <Option value="aardvrucht">Aardvrucht</Option>
                <Option value="specerijen">Specerijen</Option>
              </Select>
            </Form.Item>
       
            <Form.Item label="Product omschrijving" extra={`${productOmschrijving ? productOmschrijving.length : 0}/65`}>
              <TextArea name="productOmschrijving" onChange={this.handleInput} value={productOmschrijving} maxLength={65} />
            </Form.Item>

            <Form.Item label="Product eigenschappen" required={true}>
            <Select
                    mode="multiple"
                    placeholder="Selecteer de verschillende eigenschappen"
                    onChange={this.handleAttributenSelect}
                    value={productAttributen}
                  >
                    {attributen}
                  </Select>
            </Form.Item>

            <Form.Item label="Prijs" required={true}>
              <Input prefix="SRD" name="productPrijs" 
              onChange={this.handleNumberInput} value={productPrijs} />
            </Form.Item>

            <Form.Item label="Product eenheid" required={true}>
              <Select value={productEenheid} onChange={this.handleProductEenheid}>
                <Option value="stuk">stuk</Option>
                <Option value="hoop">hoop</Option>
                <Option value="hoop(4x)">hoop(4x)</Option>
                <Option value="hoop(8x)">hoop(8x)</Option>
                <Option value="1/2 hand">1/2 hand</Option>
                <Option value="takjes(4x)">takjes(4x)</Option>
                <Option value="bosje">bosje</Option>
                <Option value="pakje">pakje</Option>
              </Select>
            </Form.Item>

              <Checkbox onChange={this.handleOnSaleSelect} checked={productOnSale} >On sale</Checkbox>
            
            {productOnSale ? <Form.Item label="Sales prijs" required={true} >
              <Input prefix="SRD" name="salesPrice" onChange={this.handleNumberInput} value={salesPrice === 0 ? '' : salesPrice} />
            </Form.Item> : null}
          
            <Form.Item label="Product ID" required={true} help="Vul hier uw eigen product kenmerk in">
              <Input name="productId" onChange={this.handleInput} value={productId} />
            </Form.Item>

          <button onClick={this.handleProductUpdate} className="large-main-btn">Opslaan</button>

        </Form>

       {productNaam && productNaam.length > 0 ?  <div className="delete-button">
          <p>{`Type ${productNaam.toUpperCase()} in om het product te verwijderen`}</p>
          <div>
          <Input  name="confirmDelete" onChange={this.handleConfirm} value={confirmDelete}/>
          <button onClick={this.deleteProduct} className={`red-button ${confirmDelete === productNaam.toUpperCase() ? 'DELETE': ''}`}>DELETE</button>
          </div>
        </div> : null}

        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  misc: state.misc,
  products: state.products
})

export default connect(mapStateToProps, { hideProductModal, toggleProductVisibile, deleteProduct, updateProduct, showMessageModal })(EditModal)
